export const STATUS_TITLE = {
  TOTAL:    'Всего разделов',
  NOT_SUBM: 'Не представлено',
  SUBM:     'Представлено',
  CHECKING: 'На проверке',
  IN_WORK:  'В работе у КА',
  APPROVED: 'Согласован',
  GIP:      'На утверждении ГИП',
  REVOKED:  'Отозвано',
  APPR_REM: 'Согласован с замечаниями',
} as const;
